import { usePPVPopupStore } from '@/store/usePPVPopupStore'
import useStore from '@/store/useStore'

export const updateUserRightsOfEvents = async (eventId: string) => {
  const { addBoughtEventId } = usePPVPopupStore.getState()
  const { onBoughtEvent } = useStore.getState().common
  addBoughtEventId(eventId)
  onBoughtEvent(eventId)
}
